<div class="flex">
    <div class="dashboard-logo"></div>
    <div class="dashboard-container flex-row flex">
        @if (widgetsLoaded && !widgets.length) {
            <div class="cb-margin no-widgets-message start-center flex-row">
                <mat-icon class="mat-accent">info_circle</mat-icon>
                <span class="cb-margin-left">You do not have any widgets configured</span>
            </div>
        }
        @for (column of columns; track column) {
            <div class="dashboard-columns flex-col flex">
                @for (widget of getWidgetsInColumn(column); track widget) {
                    <mat-card class="dashboard-widget" [ngStyle]="{ 'min-height': widget + 'px' }">
                        <mat-card-content>
                            @if (isEditing$.value) {
                                <button
                                    mat-icon-button
                                    aria-label="Remove Widget"
                                    color="warn"
                                    class="remove-widget-button cb-error-bg"
                                    (click)="onRemoveWidgetClicked(widget)"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.DocumentsRequiringAction) {
                                <cb-dashboard-widget-document-list [widget]="widget">
                                </cb-dashboard-widget-document-list>
                            }
                            @if (
                                widget.type === DASHBOARD_WIDGET.PreconsentDocumentsRequiringAction
                            ) {
                                <cb-dashboard-widget-grouped-action-list
                                    [widget]="widget"
                                    [label]="'Outstanding Preconsent Documents'"
                                >
                                </cb-dashboard-widget-grouped-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.DesignSchemesRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Design Schemes'"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.PricingRevisionsRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Pricing Revisions'"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.WorkingDrawingsRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Working Drawings'"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.ChangeRecordsRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Change Records'"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.CouncilRfisRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Council RFIs'"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.BusinessAccountsRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Business Accounts'"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.QuestionsRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Questions'"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.TakeOffTasksRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Takeoffs'"
                                    [displayStatus]="true"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.BaseTasksRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Tasks'"
                                    [displayStatus]="false"
                                    [showDueDate]="true"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (
                                widget.type ===
                                DASHBOARD_WIDGET.ManualPurchaseOrdersRequiringApproval
                            ) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Manual Orders Requiring Approval'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (
                                widget.type ===
                                DASHBOARD_WIDGET.PostConstructionRequiresApproval
                                ) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Post Construction - Requires Approval'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (
                                widget.type ===
                                DASHBOARD_WIDGET.BuildCompleteRequiresApproval
                                ) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Build Complete - Requires Approval'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.OutstandingLotVariations) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Outstanding Lot Variations'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.RequiredQuotesAndPCSums) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Required Quotes and Unallocated PC Sums'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (
                                widget.type === DASHBOARD_WIDGET.LotDesignConceptsRequiringAction
                            ) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Concepts Requiring Action'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.LotConsentsRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Consents Requiring Action'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                            @if (widget.type === DASHBOARD_WIDGET.PreconsentsRequiringAction) {
                                <cb-dashboard-widget-action-list
                                    [widget]="widget"
                                    [label]="'Preconsents Requiring Action'"
                                    [overrideLabel]="true"
                                    [displayStatus]="false"
                                >
                                </cb-dashboard-widget-action-list>
                            }
                        </mat-card-content>
                    </mat-card>
                }
            </div>
        }
        <div class="dashboard-controls end-end flex-row flex">
            @if (isEditing$.value) {
                <div class="start-end flex-row flex">
                    @if (hasNoWidget) {
                        <div class="dashboard-tooltips add">Add Widget</div>
                    }
                    <button mat-mini-fab (click)="onAddWidgetClicked()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            }
            <div class="start-end flex-col flex" style="width: 70px">
                @if (hasNoWidget) {
                    <div class="dashboard-tooltips info">
                        @if (!isEditing$.value) {
                            <div>Configure your widgets!</div>
                        }
                        @if (isEditing$.value) {
                            <div>Finish configuring your widgets</div>
                        }
                    </div>
                }
                <button mat-fab color="accent" (click)="isEditing$.next(!isEditing$.value)">
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
